







































































import { Component, Vue, Watch, Prop, Mixins } from 'vue-property-decorator';
import { loading, enumData, validateRuleData } from '@/decorators';
import { FormModel } from 'ant-design-vue';
import SiteSourceMixin from '@/views/components/siteSource/mixin';

@Component({
  components: {
  },
})
export default class TiktokAuthPage extends Mixins(SiteSourceMixin) {
  /** 提交成功后的回调方法 */
  @Prop({ type: Function, default: null })
  private onSuccess!: () => void;
  /** 弹窗显示 */
  private visible: boolean = false;
  /** 表单 */
  private formData: TypePlatformAccount.TiktokAuthorizeData = this.initFormData();
  /** 加载状态 */
  private loading: boolean = false;
  /** Tiktok站点 */
  @enumData('Platform/TiktokSiteEnum')
  private tiktokSiteEnum: TypeBase.EnumListItem[] = [];
  /** 表单校验规则 */
  private formDataRule: TypeCommon.CommonFormRules = {
  };
  /** 表单布局-label */
  private labelCol: TypeBase.Col = { span: 6 };
  /** 表单布局-col */
  private wrapperCol: TypeBase.Col = { span: 16 };
  /** 授权站点 */
  private authorizeSite: string = '';
  /** 账号信息 */
  private platformAccount: TypePlatformAccount.PlatformInfoData | null = null;
  /** 是否从GD授权 */
  private isFromGd: boolean = false;
  @validateRuleData('/api/v1/open_api/oauth/tiktok_authorize')
  protected validateFormDataRule(validateData: any) {
    this.formDataRule = this.$util.mergeValidate({}, validateData);
  }
  /** 初始化表单 */
  private initFormData(): TypePlatformAccount.TiktokAuthorizeData {
    return {
      user_account: '',
      platform_user_name: '',
      site: '',
    };
  }

  /**
   * 获取state信息
   */
  private async tiktokStateInfo(): Promise<void> {
    const { data } = await this.$api.platform.tiktokState(window.location.search);
    this.isFromGd = data ? true : false;
    this.formData.site = data?.site;
    this.formData.user_account = data?.user_account;
    this.formData.platform_user_name = data?.platform_user_name;
  }

  private async handleOk(): Promise<void> {
    const com = this.$refs.formDataRef as FormModel;
    com.validate(async (valid: boolean, field: object): Promise<void | undefined> => {
      if (valid) {
        await this.tiktokCheckAuthorize();
        console.log(this.platformAccount, 'platformAccount');
        console.log(this.currSite, 'currSite');
        if (this.platformAccount && this.platformAccount.site_source !== this.currSite) {
          this.confirmAuthorize(this.platformAccount.site_source);
          return;
        }
        this.doAuthorize();
      }
    });
  }

  private async confirmAuthorize(siteSource: string) {
    const h = this.$createElement;
    /** 弹窗提示内容 */
    const html = h('div', { style: { 'text-align': 'left' } }, [
      h('div', [
        h('span', this.t('当前账号已在谷仓系统')),
        h('span', this.$util.getSourceSiteNname(siteSource || '')),
        h('span', this.t('完成授权，若确定授权则会将该账号的授权站点更新为')),
        h('span', this.$util.getSourceSiteNname(this.currSite)),
        h('span', this.t('，更新站点后该账号在')),
        h('span', this.$util.getSourceSiteNname(siteSource || '')),
        h('span', this.t('的历史未回告订单将无法回告跟踪号与承运商。')),
      ]),
      h('div', this.t('  确认更新授权站点？')),
    ]);
    const modal = this.$confirm({
      title: this.t('更新授权站点提示'),
      content: html,
      width: 500,
      onOk: async (): Promise<void> => {
        try {
          this.doAuthorize();
        } catch (error) {
          modal.destroy();
        }
      },
      onCancel: (): void => {
        this.loading = false;
        modal.destroy();
      },
    });
  }

  @loading('loading')
  private async doAuthorize() {
    const { data } = await this.$api.platform.tiktokAuthorize(window.location.search, this.formData);
    this.$message.success('授权成功!');
    this.handleLink();
  }

  @loading('loading')
  private async tiktokCheckAuthorize() {
    const { data } = await this.$api.platform.tiktokCheckAuthorize(this.formData);
    this.platformAccount = data;
  }

  /**
   * 跳转到平台账号管理
   */
  private handleLink() {
    this.$router.push({
      path: '/platform/account',
    });
  }

  private handleCancel() {
    console.log('handleCancel');
    window.close();
  }

  private created() {
    this.tiktokStateInfo();
  }
}
